<div class="block-validator" 
  *ngIf="fieldControl.errors && fieldControl.dirty">

  <div *ngIf="fieldControl.errors['MatchPassword']">Password not match.</div>

  <div *ngIf="fieldControl.errors['required']">This field is required.</div>

  <div *ngIf="fieldControl.errors['email']">This field must be in the email format.</div>

  <div *ngIf="fieldControl.errors['minlength']">field must contain at least {{ fieldControl.errors['minlength'].requiredLength }} characters.</div>

  <div *ngIf="fieldControl.errors['maxlength']">Your field should be maxed out {{ fieldControl.errors['maxlength'].requiredLength }} characters</div>

  <div *ngIf="fieldControl.errors['incorret']">Your field is incorret</div>
  
  <div *ngIf="fieldControl.errors['Passwords must have at least one non alphanumeric character.']">Passwords must have at least one non alphanumeric character.</div>


  <div *ngIf="fieldControl.errors['pattern']">{{ getTextPattern(fieldControl.errors['pattern']) }}</div>

</div>
